import styles from './Wordmark.module.css';

export function Wordmark() {
  return (
    <span className={styles.mark}>
      <svg className={styles.logo} viewBox="0 0 18 18" aria-hidden="true">
        <g fill="currentColor">
          <rect width="8.5" height="18" />
          <rect width="18" height="3.3" />
          <rect y="5.45" width="18" height="2.4" />
          <rect y="10.05" width="18" height="2.4" />
          <rect y="14.7" width="18" height="3.3" />
        </g>
      </svg>
      byliox<span className={styles.suffix}>voice</span>
    </span>
  );
}
